import { gql } from '@apollo/client';

const FETCH_NOTIFICATIONS_LIST = gql`
  query NotificationList($skip: Int) {
    notificationList(skip: $skip) {
      id
      message
      type
      link
      typeid
      seen
      status
      user {
        id
        fullname
        email
        photoUrl
      }
      createdAt
      updatedAt
    }
  }
`;

export default FETCH_NOTIFICATIONS_LIST;
